import React from 'react';
import { withStyles } from '@material-ui/styles';
import NumberFormat from 'react-number-format';
import { empty } from 'common/validators';

import { Link as RouterLink } from 'react-router-dom';
import {
    Grid,
    Dialog,
    DialogContent,
    TextField,
    FormControl,
    FormLabel,
    MenuItem,
    Typography,
    DialogActions,
    Button,
    InputAdornment,
    CircularProgress,
    Paper,
    Divider,
    IconButton
} from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import ArrowUpwardIcon from '@material-ui/icons/ArrowUpward';
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward';
import DeleteIcon from '@material-ui/icons/Delete';
import EuroSymbolIcon from '@material-ui/icons/EuroSymbol';

import { DialogTitle } from './components';
import UserProfile from 'UserProfile';

const styles = theme => ({
    root: {
        padding: theme.spacing(4),
        flexGrow: 1
    }
});

const DEFAULT_ROW = {
    label: '',
    qty: 1,
    amount: 1,
    unite_id: ''
};

const currencies = [
    {
        value: 'esp',
        label: 'Numéraire',
        id: 1
    },
    {
        value: 'Chèque',
        label: 'Chèque',
        id: 2
    },
    {
        value: 'CB',
        label: 'Carte bancaire',
        id: 3
    },
    {
        value: 'Prélèvement',
        label: 'Prélèvement',
        id: 4
    },
    {
        value: 'Téléphone',
        label: 'Téléphone',
        id: 5
    }
];

function CustomTextField(props) {
    const { inputRef, onChange, allowedToChangePrice, noIcon, ...other } = props;

    return (
        <TextField
            {...other}
            onChange={onChange}
            variant="outlined"
            fullWidth
            //helperText={props.name != 'total' && 'Saisir un prix unitaire'}
            InputProps={{
                readOnly: !allowedToChangePrice,
                endAdornment: noIcon ? null : (
                    <InputAdornment position="end">
                        <EuroSymbolIcon />
                    </InputAdornment>
                )
            }}
        />
    );
}

class Creation extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            ...props,
            isCreating: false,
            listOfMerchant: [],
            listOfEvent: [],
            selectedEvent: null,
            selectedUnity: '',
            selectedMerchant: '',
            listOfUnity: [],
            qte: '1',
            tarif: '',
            total: '',
            cheque: '',
            banque: '',
            observation: '',
            open: true,
            allowedToChangePrice: false,
            moyen: '',
            rows: [
                {
                    label: '',
                    qty: 1,
                    amount: 1,
                    unite_id: ''
                }
            ],
            regexp: /^[0-9\b]+$/,
            price: /^[0-9\b]+$/,
            updatePrice: false
        };
    }

    componentDidUpdate = (prevProps, prevState) => {
        if (prevState.tarif != this.state.tarif || prevState.qte != this.state.qte) {
            if (this.state.qte != '' && this.state.tarif != '') {
                this.setState({
                    total: parseFloat(this.state.qte) * parseFloat(this.state.tarif)
                });
            }
        }

        if (prevState.updatePrice !== this.state.updatePrice && this.state.updatePrice) {
            this.calculatePrice();
        }

        this.state.isCreating &&
            this.state.isCreating != prevState.isCreating &&
            this.prepareData();
    };

    componentDidMount = () => {
        this.getData();
    };

    calculatePrice = () => {
        const total = this.state.rows.reduce(
            (acc, curr) => acc + parseFloat(curr.qty ?? 0) * parseFloat(curr.amount ?? 0),
            0
        );

        this.setState({ total, updatePrice: false });
    };

    getData = () => {
        fetch(
            `https://www.${
                window.location.hostname.split('.')[1]
                    ? window.location.hostname.split('.')[0] === 'www'
                        ? window.location.hostname.split('.')[1]
                        : window.location.hostname.split('.')[0]
                    : 'dev'
            }.api.digitmarche.fr/api/domaine/get-domain-bill-for-creation`,
            {
                method: 'GET'
            }
        )
            .then(response => {
                return response.ok ? response.json() : false;
            })
            .then(data => {
                this.setState({
                    ...data
                });
            })
            .catch(
                error => {
                    console.error(error);
                    alert('Echec de la récupération des données');
                } // Handle the error response object
            );
    };

    prepareData = () => {
        const {
            moyen,
            banque,
            cheque,
            observation,
            selectedMerchant,
            selectedEvent,
            total,
            rows
        } = this.state;

        if (!selectedMerchant) {
            alert('Veuillez sélectionner un commerçant');
            this.setState({ isCreating: false });
            return;
        }

        for (const row of rows) {
            if (row.label === '') {
                alert('Le libellé de la ligne obligatoire');
                this.setState({ isCreating: false });
                return;
            }

            if (row.qty === '') {
                alert('La qantité est obligatoire');
                this.setState({ isCreating: false });
                return;
            }

            if (row.unite_id === '') {
                alert("L'unité est obligatoire");
                this.setState({ isCreating: false });
                return;
            }

            if (row.amount === '') {
                alert('Le montant de la ligne est obligatoire');
                this.setState({ isCreating: false });
                return;
            }
        }

        if (total == '') {
            alert('Veuillez saisir un montant total pour la facture');
            this.setState({ isCreating: false });
            return;
        }

        if (moyen == 2) {
            if (!banque || banque.length == 0 || !banque.replace(/\s/g, '').length) {
                alert('Veuillez saisir une banque');
                this.setState({ isCreating: false });
                return;
            }

            if (!cheque || cheque.length == 0 || !cheque.replace(/\s/g, '').length) {
                alert('Veuillez saisir un numéro de chèque');
                this.setState({ isCreating: false });
                return;
            }

            if (cheque.length != 7) {
                alert('Veuillez saisir un numéro de chèque valide (7 numéros obligatoires)');
                this.setState({ isCreating: false });
                return;
            }
        }

        const formData = new FormData();
        empty(observation) === false && formData.append('observation', observation);
        formData.append('marchand_id', selectedMerchant.id);
        formData.append('moyen', moyen);
        formData.append('total', total);
        formData.append('rows', JSON.stringify(rows));
        selectedEvent && formData.append('event', selectedEvent.id);
        moyen == 2 && formData.append('cheque', cheque);
        moyen == 2 && formData.append('banque', banque);

        this.sendData(formData);
    };

    sendData = formData => {
        fetch(
            `https://www.${
                window.location.hostname.split('.')[1]
                    ? window.location.hostname.split('.')[0] === 'www'
                        ? window.location.hostname.split('.')[1]
                        : window.location.hostname.split('.')[0]
                    : 'dev'
            }.api.digitmarche.fr/api/domaine/create-bill-for-event`,
            {
                method: 'POST',
                body: formData
            }
        )
            .then(response => {
                return response.ok ? response.json() : false;
            })
            .then(data => {
                alert('Facture n°' + data.numFacture + ' créée avec succés.');

                if (UserProfile.getConfig()?.auto_print_bill) {
                    window.location.replace(
                        `/print-bill?back=${'/domain-bills/' +
                            data.date +
                            '/' +
                            data.date}&num_facture=${
                            data.numFacture
                        }&token=${UserProfile.getToken()}&impression_en_cours.png`
                    );

                    return;
                }

                this.props.history.push('/domain-bills/' + data.date + '/' + data.date);
            })
            .catch(
                error => {
                    console.error(error);
                    this.setState({ isCreating: false });
                    alert('Echec de la récupération des données');
                } // Handle the error response object
            );
    };

    formatCash = value => {
        let montants = parseFloat(value)
            .toString()
            .split('.');
        return (
            montants[0] +
            ',' +
            (montants[1] ? (montants[1] + '00')[0] + (montants[1] + '00')[1] : '00') +
            ' €'
        );
    };

    handleClose = () => {
        this.props.history.goBack();
        this.setState({
            open: false
        });
    };

    handleMoyen = ({ target: { value } }) => {
        this.setState({
            moyen: value,
            cheque: '',
            banque: ''
        });
    };

    handleMerchantList = (event, value) => {
        this.setState({
            selectedMerchant: value
        });
    };

    handleEventList = (event, value) => {
        this.setState({
            selectedEvent: value
        });
    };

    handleQte = ({ target: { value } }) => {
        //(value === '' || this.state.regexp.test(value)) &&
        this.setState({
            qte: value
        });
    };

    handleTotalTarif = ({ target: { value, name } }) => {
        //this.state.price.test(value) &&
        this.setState({
            [name]: value
        });
    };

    handleBanque = ({ target: { value } }) => {
        this.setState({
            banque: value
        });
    };

    handleCheque = ({ target: { value } }) => {
        (value === '' || this.state.regexp.test(value)) &&
            this.setState({
                cheque: value.replace(/\s/g, '').slice(0, 7)
            });
    };

    handleObservation = ({ target: { value } }) => {
        this.setState({
            observation: value
        });
    };

    allowPriceToBeModify = () => {
        if (!this.state.allowedToChangePrice) {
            let confirm = window.confirm('Etes-vous sûr de vouloir modifier le montant total ?');
            confirm && this.setState({ allowedToChangePrice: true });
        }
    };

    handleRow = (i, k, v) => {
        const rows = [...this.state.rows];
        rows[i][k] = v;

        if (k === 'unite_id') {
            const unit = this.state.listOfUnity.find(unit => unit.id === v);
            const rows = [...this.state.rows];
            rows[i]['amount'] = unit.amount;
            rows[i]['label'] = unit.label;
        }

        this.setState({ rows, updatePrice: true });
    };

    handleUnityList = (event, value) => {
        this.setState({
            selectedUnity: value,
            updatePrice: true
        });
    };

    addRow = () => {
        const rows = [...this.state.rows];
        rows.push({ ...DEFAULT_ROW });
        this.setState({ rows, updatePrice: true });
    };

    removeRow = idx => {
        const rows = [...this.state.rows].filter((_, i) => i !== idx);
        this.setState({ rows, updatePrice: true });
    };

    moveRow = (idx, i) => {
        const rows = [...this.state.rows];

        const current = { ...rows[idx] };
        rows[idx] = { ...rows[idx + i] };
        rows[idx + i] = current;

        this.setState({ rows });
    };

    create = () => {
        this.setState({
            isCreating: true
        });
    };

    render() {
        const {
            classes,
            open,
            listOfMerchant,
            selectedMerchant,
            listOfEvent,
            selectedEvent,
            selectedUnity,
            listOfUnity,
            qte,
            total,
            tarif,
            moyen,
            banque,
            cheque,
            observation,
            allowedToChangePrice,
            isCreating,
            rows
        } = this.state;

        return (
            <Dialog fullWidth maxWidth={'sm'} onClose={this.handleClose} open={open}>
                <DialogTitle onClose={this.handleClose}>Créer une nouvelle facture</DialogTitle>
                <DialogContent dividers>
                    <Grid container direction="column" spacing={2}>
                        <Grid item>
                            <FormControl component="fieldset">
                                <FormLabel color="primary">
                                    Sélectionnez un événement (non obligatoire)
                                </FormLabel>
                            </FormControl>
                        </Grid>
                        <Grid item>
                            <Autocomplete
                                options={listOfEvent}
                                //size="small"
                                autoHighlight
                                value={selectedEvent}
                                onChange={this.handleEventList}
                                noOptionsText={'Aucun événement trouvé'}
                                getOptionLabel={option => option.label}
                                getOptionSelected={(option, value) => option.id == value.id}
                                renderInput={params => (
                                    <TextField
                                        fullWidth
                                        {...params}
                                        helperText={'Choisir un événement'}
                                        variant="outlined"
                                    />
                                )}
                            />
                        </Grid>
                        <Grid item>
                            <FormControl required component="fieldset">
                                <FormLabel color="primary">Sélectionnez un commerçant</FormLabel>
                            </FormControl>
                        </Grid>
                        <Grid item>
                            <Autocomplete
                                options={listOfMerchant}
                                //size="small"
                                autoHighlight
                                value={selectedMerchant}
                                onChange={this.handleMerchantList}
                                noOptionsText={'Aucun commerçant trouvé'}
                                getOptionLabel={option => option.raisonSociale}
                                getOptionSelected={(option, value) => option.id == value.id}
                                renderInput={params => (
                                    <TextField
                                        fullWidth
                                        {...params}
                                        helperText={'Choisir un commerçant'}
                                        variant="outlined"
                                    />
                                )}
                            />
                        </Grid>
                        <Grid item>
                            <Grid container direction="column" spacing={3}>
                                {rows.map((row, i) => (
                                    <Grid item key={i}>
                                        <Paper style={{ padding: 14 }} elevation={1}>
                                            <Grid
                                                container
                                                direction="row"
                                                spacing={2}
                                                alignItems="center"
                                                alignContent="center">
                                                <Grid item xs={2}>
                                                    <Typography color="primary" variant="body2">
                                                        Ligne n°{i + 1}
                                                    </Typography>
                                                </Grid>
                                                <Grid item xs={7}>
                                                    <Divider />
                                                </Grid>
                                                <Grid item xs={3}>
                                                    <div
                                                        style={{
                                                            display: 'flex',
                                                            gap: 7,
                                                            justifyContent: 'center'
                                                        }}>
                                                        <IconButton
                                                            size="small"
                                                            disabled={i === 0}
                                                            onClick={() => this.moveRow(i, -1)}>
                                                            <ArrowUpwardIcon fontSize="small" />
                                                        </IconButton>
                                                        <IconButton
                                                            size="small"
                                                            disabled={
                                                                i === this.state.rows.length - 1
                                                            }
                                                            onClick={() => this.moveRow(i, 1)}>
                                                            <ArrowDownwardIcon fontSize="small" />
                                                        </IconButton>
                                                        <IconButton
                                                            size="small"
                                                            disabled={this.state.rows.length === 1}
                                                            onClick={() => this.removeRow(i)}>
                                                            <DeleteIcon fontSize="small" />
                                                        </IconButton>
                                                    </div>
                                                </Grid>
                                                <Grid item xs={12}>
                                                    <TextField
                                                        select
                                                        fullWidth
                                                        label="Unité"
                                                        value={row.unite_id}
                                                        onChange={v => {
                                                            this.handleRow(
                                                                i,
                                                                'unite_id',
                                                                v.target.value
                                                            );
                                                        }}
                                                        variant="outlined">
                                                        {selectedEvent?.unit?.length > 0
                                                            ? listOfUnity
                                                                  .filter(u => selectedEvent.unit.includes(u.id))
                                                                  .map(unit => (
                                                                      <MenuItem
                                                                          key={unit.id}
                                                                          value={unit.id}>
                                                                          {unit.label}
                                                                      </MenuItem>
                                                                  ))
                                                            : listOfUnity.map(unit => (
                                                                  <MenuItem
                                                                      key={unit.id}
                                                                      value={unit.id}>
                                                                      {unit.label}
                                                                  </MenuItem>
                                                              ))}
                                                    </TextField>
                                                </Grid>
                                                <Grid item xs={6}>
                                                    <NumberFormat
                                                        label="Quantité"
                                                        value={row.qty}
                                                        customInput={CustomTextField}
                                                        allowedToChangePrice={true}
                                                        onValueChange={v =>
                                                            this.handleRow(i, 'qty', v.value)
                                                        }
                                                        noIcon
                                                        thousandsGroupStyle="fr"
                                                        thousandSeparator={' '}
                                                        decimalSeparator={'.'}
                                                        type={'text'}
                                                        allowedDecimalSeparators={[
                                                            ',',
                                                            '.',
                                                            '?',
                                                            ';'
                                                        ]}
                                                        allowNegative={false}
                                                        decimalScale={2}
                                                        isNumericString
                                                    />
                                                </Grid>
                                                <Grid item xs={6}>
                                                    <NumberFormat
                                                        label="Prix unitaire"
                                                        value={row.amount}
                                                        customInput={CustomTextField}
                                                        allowedToChangePrice={true}
                                                        onValueChange={v =>
                                                            this.handleRow(i, 'amount', v.value)
                                                        }
                                                        thousandsGroupStyle="fr"
                                                        thousandSeparator={' '}
                                                        decimalSeparator={','}
                                                        type={'text'}
                                                        allowedDecimalSeparators={[
                                                            ',',
                                                            '.',
                                                            '?',
                                                            ';'
                                                        ]}
                                                        allowNegative={false}
                                                        decimalScale={2}
                                                        isNumericString
                                                    />
                                                </Grid>
                                            </Grid>
                                        </Paper>
                                    </Grid>
                                ))}
                                <Grid item>
                                    <Button
                                        fullWidth
                                        variant="outlined"
                                        size="small"
                                        color="secondary"
                                        onClick={() => this.addRow()}>
                                        Ajouter une ligne
                                    </Button>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item style={{ marginTop: 10 }}>
                            <FormControl required component="fieldset">
                                <FormLabel color="primary">Total</FormLabel>
                            </FormControl>
                        </Grid>
                        <Grid item>
                            <NumberFormat
                                value={total}
                                customInput={CustomTextField}
                                allowedToChangePrice={true}
                                // helperText={'Saisir un prix unitaire'}
                                onValueChange={values => {
                                    this.handleTotalTarif({
                                        target: {
                                            name: 'total',
                                            value: values.value
                                        }
                                    });
                                }}
                                onChange={this.handleTotalTarif}
                                thousandsGroupStyle="fr"
                                thousandSeparator={' '}
                                decimalSeparator={','}
                                type={'text'}
                                allowedDecimalSeparators={[',', '.', '?', ';']}
                                allowNegative={false}
                                decimalScale={2}
                                isNumericString
                            />
                        </Grid>
                        <Grid item style={{ marginTop: 10 }}>
                            <FormControl component="fieldset">
                                <FormLabel color="primary">
                                    Moyen de paiement (facultatif)
                                </FormLabel>
                            </FormControl>
                        </Grid>
                        <Grid item>
                            <TextField
                                select
                                fullWidth
                                //size="small"
                                variant="outlined"
                                value={moyen}
                                helperText={'Choisir un moyen de paiement'}
                                onChange={this.handleMoyen}>
                                {currencies.map(option => (
                                    <MenuItem key={option.id} value={option.id}>
                                        <Typography variant="body1" color="primary">
                                            {option.label}
                                        </Typography>
                                    </MenuItem>
                                ))}
                            </TextField>
                        </Grid>
                        {moyen == 2 && (
                            <React.Fragment>
                                <Grid item>
                                    <TextField
                                        //size="small"
                                        name="banque"
                                        variant="outlined"
                                        fullWidth
                                        helperText="Saisir une banque"
                                        onChange={this.handleBanque}
                                        placeholder="Ma banque"
                                        value={banque}
                                    />
                                </Grid>
                                <Grid item>
                                    <TextField
                                        //size="small"
                                        variant="outlined"
                                        name="cheque"
                                        helperText="Saisir un numéro de chèque"
                                        fullWidth
                                        value={cheque}
                                        onChange={this.handleCheque}
                                        placeholder="1234567"
                                    />
                                </Grid>
                            </React.Fragment>
                        )}
                        <Grid item style={{ marginTop: 10 }}>
                            <FormControl component="fieldset">
                                <FormLabel color="primary">Observation (facultatif)</FormLabel>
                            </FormControl>
                        </Grid>
                        <Grid item>
                            <TextField
                                variant="outlined"
                                //size="small"
                                multiline
                                fullWidth
                                rows={5}
                                rowsMax={10}
                                value={observation}
                                helperText={'Saisir une observation'}
                                onChange={this.handleObservation}
                            />
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    {isCreating && <CircularProgress color="primary" size={25} />}
                    <Button onClick={this.handleClose} color="primary">
                        Annuler la création
                    </Button>
                    <Button
                        onClick={this.create}
                        disabled={isCreating}
                        variant="contained"
                        color="primary">
                        Créer la facture
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }
}

export default withStyles(styles)(Creation);
